// ** React Imports
import { lazy } from 'react';

const AppRoutes = [
  {
    path: '/',
    component: lazy(() => import('pages/home')),
  },
  {
    path: 'maintenance-policies',
    component: lazy(() => import('pages/maintaining-policies')),
  },
  {
    path: 'case-management',
    component: lazy(() => import('pages/case_management')),
  },
  {
    path: 'case-management/:id',
    component: lazy(() => import('pages/case_management_show')),
  },
  {
    path: 'users',
    component: lazy(() => import('pages/users')),
  },
  {
    path: 'reports',
    component: lazy(() => import('pages/reports')),
  },
];

export default AppRoutes;
